export const mainLanguageCodesArray: string[] = ['en', 'en_UK', 'de', 'da', 'fr', 'fr_CA', 'sv'];
